export const ResourceLocaleId = '9688cd08-adef-408c-9d34-5d75ae5c44df';
//# sourceMappingURL=resource.dto.js.map